import PropTypes from 'prop-types';

const { string, shape } = PropTypes;

export default shape({
  url: string,
});
